import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ImageManagementComponent } from './image-management.component';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { ProductImagesComponent } from './product-images/product-images.component';
import { UploadAdditionalImagesComponent } from './product-images/upload-additional-images/upload-additional-images.component';
import { ManageImagesComponent } from './product-images/manage-images/manage-images.component';

export const imageroutes: Routes = [
  {
    path:'',
    component:ImageManagementComponent,
    children:[
      {
        path:'product-galleries',
        component:ImageManagementComponent
      }
    ]
  },
  {
    path:'product-galleries/gallery/product-images/:productId/:event',
    component:ProductImagesComponent
  },
  {
    path:'product-galleries/gallery/product-image/:productId/:event',
    component:ProductImagesComponent
  },
  {
    path:'product-galleries/gallery/:productId/manage',
    component:ManageImagesComponent,
  },
  {
    path:'product-galleries/gallery/:productId/new',
    component:UploadAdditionalImagesComponent
  }
]

export const baseMenuItems:NbMenuItem[] = [
  {
      title:"Product Image Management",
      group:true
  },
  {
      title:"Browse Product Galleries",
      icon:"list-outline",
      link:"/admin/img/product-galleries",
      data:{
          event:"list",
          type:"ListProductCategoryMembers",
          data:{
          formData:{
              formName:"ListProductCategoryMembers",
              formLocation:"component://kwikstore/widget/ImageManagementForms.xml"
          },
          appContext:"catalog",
          }
      }
  }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(imageroutes),
    UbsViewContainersModule
  ]
})
export class ImageManagementRoutingModule {
  menuItems:NbMenuItem[] = [];
  headerTitle:string = "Image";
  path:string = "img";
  menuTag:string = "imageMenu"
  menuAndTitleOptions = {path:this.path,menuItems:baseMenuItems,headerTitle:this.headerTitle,menuTag:this.menuTag};

  constructor(
    private viewContainerService:ViewContainersService,
    private menuService:NbMenuService){
      this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(this.menuTag);
    /* baseMenuItems.forEach(item => {
      this.menuItems.push(item);
    }); */
    //this.menuService.addItems(this.menuItems,this.menuTag);
  }
 }
